import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../store/auth';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ login:'', password:'' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const { data } = await api.post('/auth/login', form);
      login(data.user);
      nav(data.user.role === 'TECH' || data.user.role === 'CHEF' ? '/rapport' : '/dashboard');
    } catch(e) {
      setErr(e.response?.data?.error || 'Erreur de connexion');
    } finally { setLoading(false); }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img src="/logo.png" alt="LIDWORK" style={styles.logoImg}/>
          <p style={styles.sub}>Piloter aujourd'hui les entrepôts de demain</p>
        </div>
        <form onSubmit={submit} style={styles.form}>
          <label style={styles.label}>Identifiant</label>
          <input style={styles.input} value={form.login} autoCapitalize="none"
            onChange={e => setForm(f => ({...f, login:e.target.value}))} required/>
          <label style={styles.label}>Mot de passe</label>
          <input style={styles.input} type="password" value={form.password}
            onChange={e => setForm(f => ({...f, password:e.target.value}))} required/>
          {err && <p style={styles.err}>{err}</p>}
          <button style={styles.btn} disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page:{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
         background:'linear-gradient(135deg,#1E3A6E 0%,#2E75B6 100%)', padding:16 },
  card:{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:400,
         boxShadow:'0 8px 32px rgba(0,0,0,.2)' },
  logo:{ textAlign:'center', marginBottom:28 },
  logoImg:{ width:'100%', maxWidth:280, marginBottom:4 },
  title:{ fontSize:22, fontWeight:700, color:'#1F4E79' },
  sub:{ fontSize:13, color:'#666', marginTop:4 },
  form:{ display:'flex', flexDirection:'column', gap:12 },
  label:{ fontSize:13, fontWeight:600, color:'#333' },
  input:{ border:'1.5px solid #e0e0e0', borderRadius:8, padding:'12px 14px',
          fontSize:16, outline:'none', transition:'border .2s',
          ':focus':{ borderColor:'#2E75B6' } },
  err:{ color:'#C62828', fontSize:13, textAlign:'center' },
  btn:{ background:'#1F4E79', color:'#fff', borderRadius:8, padding:'14px',
        fontSize:16, fontWeight:600, marginTop:4,
        ':disabled':{ opacity:.6 } },
};
